interface TextareaChangeLike {
  target: { value: string };
}

export const resolveRenderMobileView = (
  renderMobileView: boolean | undefined,
  isDesktop: boolean
): boolean => (renderMobileView !== undefined ? renderMobileView : !isDesktop);

export const wrapOnChangeWithWaveformStop = (
  onChange: ((event: TextareaChangeLike) => void) | undefined,
  dispatchWaveformStop: () => void
): ((event: TextareaChangeLike) => void) => {
  return (event) => {
    if (event.target.value) {
      dispatchWaveformStop();
    }
    onChange?.(event);
  };
};
